import * as Property from '../util/Element';
import { addListeners, clearEventListeners } from '../util/Event';
/**
 *
 * @var {attribute.n} name Nombre del atributo
 * @var {attribute.a} attribute Elemento del DOM que representa el atributo
 * @var {attribute.$} $element Elemento HTML al que pertenece el atributo
 * @var {attribute.pn} propertyName Nombre de la propiedad a la que pertenece el atributo
 * @var {attribute.exp} expression? Expresión que se debe evaluar para que tome el valor el atributo
 */
function setAttribute($attribute, name, property) {
  const isObject = property instanceof Object;
  if ($attribute.tagName?.includes("-")) {
    if (isObject) {
      property = JSON.stringify(property);
    }
    $attribute.setAttribute(name, property || '');
  } else if (isObject && $attribute[name] instanceof Object) {
    for (const key in property) {
      setAttribute($attribute[name], key, property[key]);
    }
  } else if ($attribute[name] !== property) {
    $attribute[name] = property;
  }
}

export function create(property, name, $node, prop, exp) {
  const keys = name.split('.');
  const value = property.v;
  let $attribute = $node;
  name = keys.pop();
  keys.forEach((k) => {
    $attribute = $attribute[k];
    if (process.env.NODE_ENV !== 'production' && !$attribute) {
      throw new Error(`Attribute ${k} not found`);
    }
  });
  const attribute = { n: name, a: $attribute, $: $node, pn: prop, f: exp ? Function('p', 'return ' + exp) : null };
  exp || Property.getValue(value, prop) ? execute(property, attribute, value) : Property.setValue(property, prop, $attribute[name]);
  return attribute;
}

export function execute(property, attribute, value) {
  const { $: $node, n: name } = attribute;
  const privyComponent = property.pc;
  if (!$node.isConnected) {
    return property.a_.delete($node);
  }
  value = attribute.f ? attribute.f(property.c) : Property.getValue(value, attribute.pn);
  setAttribute(attribute.a, name, value);
  if (name.indexOf('class') === 0 || name === 'id') {
    clearEventListeners($node, 1);
    addListeners(privyComponent.$, privyComponent.e_);
  }
}
